export const URLHOST = process.env.REACT_APP_ENDPOINT
  ? process.env.REACT_APP_ENDPOINT
  : 'https://beta-preventage-web.profsoft.online'
export const URLHOSTBACKEND = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/api`
  : 'https://beta-preventage-web.profsoft.online/api'
export const URLHOSTLANDING = process.env.REACT_APP_ENDPOINT
  ? process.env.REACT_APP_ENDPOINT
  : 'https://beta-preventage-web.profsoft.online'
export const URLHOSTADMIN = process.env.REACT_APP_ENDPOINT
  ? `${process.env.REACT_APP_ENDPOINT}/admin/`
  : 'https://beta-preventage-web.profsoft.online/admin/'
export const URL_CLOUD =
  process.env.REACT_APP_CLOUD_URL ??
  'https://preventage.website.yandexcloud.net'
